import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-hover-mask',
  imports: [RouterModule],
  templateUrl: './hover-mask.html',
  styleUrl: './hover-mask.scss',
})
export class HoverMask {
  @Input({ required: true }) title: string = '';
  @Input() categoryId: number = 0;
}
